<script>
import { get } from 'lodash';
import { mapMutations } from 'vuex';
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import DropZone from 'vue2-dropzone';

import FileUpload from '@/components/FileUpload';
import API from '@/api';

export default {
  name: 'ModuleCoursesEditionLecture',
  components: {
    CKEditor: CKEditor.component,
    DropZone,
    FileUpload,
  },
  props: {
    item: {
      type: Object,
      required: false,
      default: () => ({
        name: null,
        content: null,
        video: {
          videoUrl: null,
          mobileVideoUrl: null,
          video: null,
          mobileVideo: null,
          content: null,
        },
        material: {
          content: null,
          files: [],
        },
      }),
    },
    order: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      localData: this.item,
      editor: ClassicEditor,
      editorConfig: {},
      dropZoneOptions: {
        url: `${API}/panel/upload/`,
        maxFilesize: 10,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          'Content-Encoding': 'gzip'
        },
      },
    };
  },
  computed: {
    inputId() {
      return `lecture_${this.order + 1}_`;
    },
    name: {
      get() {
        const defaultName = `Część ${this.order + 1}`;
        let { name = defaultName } = this.localData;

        if (!name || name.length < 1) {
          name = defaultName;
        }

        return name;
      },
      set(value) {
        const { localData } = this;
        localData.name = value;
        this.updateLecture(this.order, localData);
      },
    },
    content: {
      get() {
        return this.item.content || '';
      },
      set(value) {
        const { localData } = this;
        localData.content = value;
        this.updateLecture(this.order, localData);
      },
    },
    videoUrl: {
      get() {
        return get(this.localData, 'video.videoUrl', null);
      },
      set(value) {
        const { localData, order } = this;

        if (!localData.video) {
          localData.video = {};
        }

        localData.video.videoUrl = value;

        this.updateLecture({ index: order, data: localData });
      },
    },
    videoContent: {
      get() {
        const content = get(this.localData, 'video.content', '');
        return content === null ? '' : content;
      },
      set(value) {
        const { localData, order } = this;

        if (!localData.video) {
          localData.video = {};
        }

        localData.video.content = value;
        this.updateLecture({ index: order, data: localData });
      },
    },
    videoFile: {
      get() {
        return get(this.localData, 'video.video', null);
      },
      set(value) {
        const { localData, order } = this;

        if (!localData.video) {
          localData.video = {};
        }

        localData.video.video = value;

        this.updateLecture({ index: order, data: localData });
      },
    },
    mobileVideoFile: {
      get() {
        return get(this.localData, 'video.mobile', null);
      },
      set(value) {
        const { localData, order } = this;

        if (!localData.video) {
          localData.video = {};
        }

        localData.video.mobile = value;

        this.updateLecture({ index: order, data: localData });
      },
    },
    materialContent: {
      get() {
        const content = get(this.localData, 'material.content', '');
        return content === null ? '' : content;
      },
      set(value) {
        const { localData, order } = this;

        if (!localData.material) {
          localData.material = {};
        }
        localData.material.content = value;
        this.updateLecture({ index: order, data: localData });
      },
    },
    files() {
        const files = get(this.localData, 'material.files', []);
        return files === null ? [] : files;
    },
  },
  methods: {
    ...mapMutations('course/item', [
      'updateLecture',
      'removeLecture',
    ]),
    remove() {
      this.removeLecture(this.order);
    },
    eventBeforeUpload(file, xhr, formData) {
      formData.append('directory', 'course');
      formData.append('fileName', file.name.split('.').slice(0, -1).join('.'));
    },
    eventUploadSuccess(file, response) {
      const image = response;
      const { localData, order } = this;

      if (!localData.material) {
        localData.material = {
          files: [],
        };
      }

      if (!localData.material.files) {
        localData.material.files = [];
      }

      localData.material.files.push(image);
      this.updateLecture({ index: order, data: localData });

      this.$refs.dropzone.removeFile(file);
    },
    removeFile(index) {
      const { localData, order } = this;

      if (!localData.material.files[index]) {
        return;
      }

      localData.material.files.splice(index, 1);
      this.updateLecture({ index: order, data: localData });
    }
  },
  created() {
    const { localData, name } = this;

    localData.name = name;

    if (!localData.material) {
      localData.material = {
        content: null,
        files: [],
      };
    }

    if (!localData.video) {
      localData.video = {
        videoUrl: null,
        mobileVideoUrl: null,
        content: null,
      };
    }
  },
};
</script>
<style lang="scss" scoped>
    @import '~vue2-dropzone/dist/vue2Dropzone.min.css';
</style>
<template>
    <div class="box mt-3">
        <h1 class="h3 mb-3">{{ name }}</h1>
        <h2>Video</h2>
        <FileUpload :id="`${inputId}video_file`" className="form-group pb-3" directory="courses" v-model="videoFile" label="Video" />
        <!-- <FileUpload :id="`${inputId}mobile_video_file`" className="form-group pb-3" directory="courses" v-model="mobileVideoFile" label="Mobile Video" /> -->
        <div class="form-group mt-3">
            <label :for="`${inputId}video_content`" class="d-block">Content</label>
            <CKEditor :id="`${inputId}video_content`" :editor="editor" v-model="videoContent" :config="editorConfig" />
        </div>
        <h2>Material</h2>
        <div class="form-group mt-3">
            <label :for="`${inputId}material_content`" class="d-block">Content</label>
            <CKEditor :id="`${inputId}material_content`" :editor="editor" v-model="materialContent" :config="editorConfig" />
        </div>
        <div class="form-group mt-3">
            <label class="d-block">Files</label>
            <ul>
                <li v-for="(file, index) in localData.material.files" :key="index" class="d-flex justify-content-between align-content-center mt-3">
                    <span>{{ index + 1 }}. {{ file.name }}</span>
                    <button class="btn btn-sm btn-danger" @click="removeFile(index)">remove</button>
                </li>
            </ul>
        </div>

        <DropZone
                :id="`${inputId}_dropzone`"
                ref="dropzone"
                :options="dropZoneOptions"
                :duplicateCheck="true"
                @vdropzone-sending="eventBeforeUpload"
                @vdropzone-success="eventUploadSuccess"
        />

        <div class="text-right mt-3">
            <button class="btn btn-danger" @click="remove">Remove</button>
        </div>
    </div>
</template>
